<script lang="ts">
export default {
  name: 'ProgramsLibraryButton',
};
</script>

<script setup lang="ts">
import { StoreMutationType } from '@/types/StoreMutationType';
import { inject } from 'vue';
import { Store } from 'vuex';
import { AppState } from '@/store';
import { Library } from 'lucide-vue-next';

const store = inject<Store<AppState>>('store');

function showProgramsPanel(e: MouseEvent) {
  e.stopPropagation();
  store?.commit(StoreMutationType.SET_PROGRAMS_PANEL_STATE, { show: true });
}
</script>

<template>
  <div class="library">
    <label title="Program Library">
      <input
        type="checkbox"
        name="editor-programs"
        aria-label="Programs Library"
        class="programs-library-input"
        @click="showProgramsPanel" />
      <Library
        class="sidebar-button button toggle-button tw:border-box tw:pointer-events-auto tw:flex tw:h-10 tw:w-10 tw:cursor-pointer tw:items-center tw:rounded-lg tw:p-2 tw:shadow-lg" />
    </label>
  </div>
</template>

<style scoped>
.library {
  padding: 0.5rem;
  grid-column-start: 3;
  grid-row-start: 1;
  justify-self: end;
}

.programs-library-input {
  position: absolute;
  pointer-events: none;
  opacity: 0;
}

.sidebar-button {
  cursor: pointer;
  pointer-events: all;
  background-color: var(--tower-v2-alt-bg-color);
  box-sizing: border-box;
  border: 1px solid var(--tower-v2-border-color);
  border-radius: 0.5rem;
  width: 2.5rem;
  height: 2.5rem;
}

.sidebar-button:hover {
  background-color: #cec0b5;
}
</style>
